"use strict";

// ------------------------------------------------------------------------------
// <auto-generated>
// This code was generated by the @augloop/code-gen tool.
// Source: https://office.visualstudio.com/GSX/_git/AugmentationLoop?path=%2Fmodules%2Ftypes-core%2Fsrc%2Fannotations.ts
// Changes to this file may cause incorrect behavior and will be lost upon regeneration.
// </auto-generated>
// ------------------------------------------------------------------------------
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BinaryClassificationAnnotation = exports.Annotation = void 0;
var schema_object_g_1 = require("./schema-object.g");
var Annotation = /** @class */function () {
  function Annotation(obj) {
    schema_object_g_1.SchemaObject.assign(Annotation, this, obj);
  }
  Annotation.getTypeName = function () {
    return 'AugLoop_Core_Annotation';
  };
  Annotation.getBaseTypes = function () {
    return [];
  };
  Annotation.H_ = {
    T_: Annotation.getTypeName(),
    B_: Annotation.getBaseTypes()
  };
  return Annotation;
}();
exports.Annotation = Annotation;
var BinaryClassificationAnnotation = /** @class */function () {
  function BinaryClassificationAnnotation(obj) {
    schema_object_g_1.SchemaObject.assign(BinaryClassificationAnnotation, this, obj);
  }
  BinaryClassificationAnnotation.getTypeName = function () {
    return 'AugLoop_Core_BinaryClassificationAnnotation';
  };
  BinaryClassificationAnnotation.getBaseTypes = function () {
    return ['AugLoop_Core_Annotation'];
  };
  BinaryClassificationAnnotation.H_ = {
    T_: BinaryClassificationAnnotation.getTypeName(),
    B_: BinaryClassificationAnnotation.getBaseTypes()
  };
  return BinaryClassificationAnnotation;
}();
exports.BinaryClassificationAnnotation = BinaryClassificationAnnotation;